export const pageTitle = title => {
  return (document.title =
    title + ' - BRR Diagnostics - Every test, Every time, Accurate');
};
